import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Full background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/55d4ee9f04abdd19fe0b148f34a80493.jpg')`,
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/80 to-navy/40" />
      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,230,122,1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,230,122,1) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />
      {/* Green glow top-right */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] rounded-full bg-accent/5 blur-3xl pointer-events-none" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-accent/15 border border-accent/30 rounded-full px-4 py-1.5 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent animate-pulse shrink-0"></span>
            <span className="text-accent text-sm font-body font-semibold">Metairie &amp; Greater New Orleans — Licensed &amp; Insured</span>
          </div>

          <h1 className="font-heading font-extrabold text-white text-5xl xl:text-7xl leading-[1.05] mb-6">
            Commercial Cleaning That Keeps Your Business{' '}
            <span className="text-accent">Spotless</span>
          </h1>

          <p className="text-white/65 text-xl font-body leading-relaxed mb-10 max-w-xl">
            Reliable janitorial services for offices, commercial buildings, and facilities — customized to your schedule, standards, and budget.
          </p>

          <div className="flex flex-wrap gap-4 mb-14">
            <Link
              to="/contact"
              className="bg-accent hover:bg-accent-dark text-navy font-heading font-extrabold text-base px-9 py-4 rounded-full transition-all duration-200 whitespace-nowrap flex items-center gap-2"
            >
              Get a Free Quote
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
            <a
              href="tel:+15048183347"
              className="bg-white/10 hover:bg-white/20 border border-white/20 text-white font-heading font-bold text-base px-9 py-4 rounded-full transition-all duration-200 whitespace-nowrap flex items-center gap-2 backdrop-blur-sm"
            >
              <i className="ri-phone-fill text-accent"></i>
              (504) 818-3347
            </a>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap gap-8">
            {[
              { value: '20+', label: 'Years Serving Louisiana' },
              { value: '500+', label: 'Commercial Clients' },
              { value: '5.0★', label: 'Google Rating' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="font-heading font-extrabold text-accent text-3xl">{stat.value}</span>
                <span className="text-white/50 font-body text-sm mt-0.5">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right floating panel — desktop only */}
        <div className="absolute right-6 bottom-20 hidden xl:block w-80">
          <div className="bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4 pb-4 border-b border-white/10">
              <img
                src="https://ojsjanitorial.net/wp-content/uploads/2023/04/logo.png"
                alt="OJS Janitorial"
                className="h-10 w-auto object-contain"
              />
              <div>
                <div className="text-white font-heading font-bold text-sm">OJ&apos;s Janitorial</div>
                <div className="text-accent text-xs font-body">&amp; Sweeping Service, LLC</div>
              </div>
            </div>
            <div className="space-y-2.5">
              {[
                { icon: 'ri-shield-check-line', label: 'GSA Federal Contractor' },
                { icon: 'ri-virus-line', label: 'GBAC COVID-19 Certified' },
                { icon: 'ri-medal-line', label: 'BBB Accredited Business' },
                { icon: 'ri-government-line', label: 'LA Contractor License #71638' },
              ].map((c) => (
                <div key={c.label} className="flex items-center gap-2.5">
                  <i className={`${c.icon} text-accent text-sm`}></i>
                  <span className="text-white/70 font-body text-xs">{c.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <div className="w-5 h-8 border border-white/30 rounded-full flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
